export enum AppPaths {
  SIGN_IN = "/sign-in",

  HOME = "/",
  HOME_ALL = "/*",

  Specialists_All = "/specialists/*",
  Specialists = "/specialists",
  Specialists_List = "/specialists/list",
  Specialists_List_Short = "/list",
  Specialists_View = "/specialists/view",
  Specialists_View_Short = "/view",
  Specialists_New = "/specialists/new",
  Specialists_New_Short = "/new",
  Specialists_Edit = "/specialists/edit",
  Specialists_Edit_Short = "/edit",

  OrganizationsAll = "/organizations/*",
  Organizations = "/organizations",
  OrganizationsNew = "new",
  OrganizationsEditOne = ":id/edit",
  OrganizationsStatistics = ":id/statistics",
  OrganizationsPhysiosList = ":id/physios-list",
  OrganizationsPatientsList = ":id/patients-list",

  UserSearch_All = "/user-search/*",
  UserSearch = "/user-search",
  UserSearch_List = "/user-search/search",
  UserSearch_List_Short = "/search",
  UserSearch_View = "/user-search/view",
  UserSearch_View_Short = "/view",

  Settings_All = "/settings/*",
  Settings = "/settings",
}
